import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../../auth/service";
import { Router } from "@angular/router";
import { locale as italian } from "../../../../../i18n/it";
import { TransformationService } from "../../../transformation.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { CustomerService } from "../../../../customer/customer.service";

@Component({
  selector: "app-transformation-list",
  templateUrl: "./transformation-list.component.html",
  styleUrls: ["./transformation-list.component.scss"],
})
export class TransformationListComponent implements OnInit {
  public filter_status: number = -1;
  public filter_string: string = "";
  public tableLimit: number = 10;
  public filtered_list: any = [];
  public contentHeader: IContentHeader = null;
  public statusTransformationLabels: any = [];
  public transformationList: any = [];
  public statusDocument: any = [
    {
      label: "NOT_SENDED_PLURAL",
      color: "secondary",
    },
    {
      label: "SENDED_PLURAL",
      color: "info",
    },
    {
      label: "TO_APPROVED",
      color: "warning",
    },
    {
      label: "APPROVED_MALE_PLURAL",
      color: "success",
    },
    {
      label: "NOT_APPROVED_PLURAL_MALE",
      color: "danger",
    },
  ];
  public statusContract: any = [
    {
      label: "NOT_SENDED",
      color: "secondary",
    },
    {
      label: "SENDED",
      color: "info",
    },
    {
      label: "TO_APPROVED",
      color: "warning",
    },
    {
      label: "APPROVED",
      color: "success",
    },
    {
      label: "NOT_APPROVED",
      color: "danger",
    },
  ];

  constructor(
    public customerService: CustomerService,
    public _utilService: UtilsService,
    public router: Router,
    public _authenticationService: AuthenticationService,
    public _transformationService: TransformationService,
  ) {
    this._utilService.disableAutoHideLoading();
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_transformation")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
    }
    await this.loadTransformation();
    await this.search();
    await this._utilService.translate("IN_PROGRESS").then((item: string) => this.statusTransformationLabels.push(item));
    await this._utilService.translate("COMPLETE").then((item: string) => this.statusTransformationLabels.push(item));
    await this._utilService.translate("DISABLED").then((item: string) => this.statusTransformationLabels.push(item));
    this.contentHeader = {
      headerTitle: italian.data.MENU.TRANSFORMATION,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.USERS,
            isLink: false,
          },
          {
            name: italian.data.MENU.TRANSFORMATION,
            isLink: false,
          },
        ],
      },
    };
    this._utilService.hideLoading();
  }

  async loadTransformation() {
    this.transformationList = await this._transformationService.getTransformationList();
    this.transformationList.map((item: any) => {
      item.status_document = item.status_document || 0;
      item.status_contract = item.status_contract || 0;
    });
    //Controllo che ci siano trasformazioni attive e setto lo stato della select su quelle attive, se no su tutte
    const transformationActivatedList: any = this.transformationList.filter((item: any) => item.status === 0).length;
    if (transformationActivatedList > 0) {
      this.filter_status = 0;
    } else {
      this.filter_status = -1;
    }
    setTimeout(() => this._utilService.hideLoading());
  }

  async search() {
    const keyword: string = this.filter_string.toLowerCase().trim();
    let filteredList: any = this.transformationList;
    if (keyword.length > 0) {
      filteredList = filteredList.filter((item: any) => {
        return item.user.complete_name.toLowerCase().includes(keyword);
      });
    }
    if (this.filter_status > -1) {
      filteredList = filteredList.filter((item: any) => Number(item.status) === Number(this.filter_status));
    }
    this.filtered_list = filteredList;
  }

  async deleteTransformation(idTransformation) {
    if (!this._authenticationService.hasCapability("delete_transformation")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");

    await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
      if (result.value) {
        await this._transformationService
          .deleteTransformation(idTransformation)
          .catch(() => this._utilService.showSWALError({ text: "ERROR_REMOVE_TRANSFORMATION" }))
          .then(async () => {
            await this._utilService.showPopupItemDeleted();
            this.transformationList = this.transformationList.filter((item: any) => {
              return item.id != idTransformation;
            });
            await this.search();
          });
      } else if (result.isDismissed) {
        await this._utilService.showSWALError({
          title: "ABORTED_TITLE",
          text: "ABORTED_TEXT",
        });
      }
    });
  }

  async restoreTransformation(idTransformation) {
    if (!this._authenticationService.hasCapability("edit_transformation")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    // popup
    await this._utilService
      .showSWAL({
        title: "CONFIRM_RESTORE_TITLE",
        icon: "warning",
        confirmButtonText: "CONFIRM_RESTORE_BTN",
        customClass: {
          confirmButton: "btn btn-success",
        },
      })
      .then(async (result) => {
        if (result.value) {
          await this._transformationService
            .updateTransformationStatus(idTransformation, { status: 1, note: null })
            // controllare i testi
            .then(async () => {
              await this.loadTransformation();
              await this.search();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_RESTORE_TRANSFORMATION" });
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_RESTORE_TRANSFORMATION" }));
        }
      });
  }

  async requestDocumentMasterData(currentTransformation: any) {
    if (!this._authenticationService.hasCapability("edit_transformation")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    await this._transformationService
      .request_masterdata_collaborator(currentTransformation.user.hash)
      .then(async () => {
        this._utilService.hideLoading();
        currentTransformation.status_document = 1;
        await this._utilService.showSWALSuccess({ text: "MASTERDATA_SENDED" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "MASTERDATA_SENDED_ERROR" });
      });
  }

  async requestDocumentContract(currentTransformation: any) {
    if (!this._authenticationService.hasCapability("edit_transformation")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    await this._transformationService
      .request_sign_contract_collaborator(currentTransformation.user.hash)
      .then(async () => {
        this._utilService.hideLoading();
        currentTransformation.status_contract = 1;
        await this._utilService.showSWALSuccess({ text: "SUCCESS_REQUEST_CONTRACT_DOCUMENT" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_REQUEST_CONTRACT_DOCUMENT" });
      });
  }
}
